// extracted by mini-css-extract-plugin
export default {"header":"HeaderContentWithUpdatedLabel__header-xlxrA","icon":"HeaderContentWithUpdatedLabel__icon-ti670","iconWithTooltip":"HeaderContentWithUpdatedLabel__iconWithTooltip-qFikq"};